/**
 * 高级筛选
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import { Popover,Button, Spin } from "antd";
import Lang from "@/components/Lang/Lang";
import dayjs from 'dayjs';
import FormFormat from '@/components/FormFormat/FormFormat';
import { isEmptyObject,} from "@utils/utils";
import "./SeniorFilter.less"
export default class SeniorFilter extends React.Component{
    static defaultProps = {
        labelType:"1010",//	1010:新客标签 1020:成交客户标签
        isAllTab:true,//默认是全部页签
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showyOptions : [
                {
                    name:'cityCode',
                    cnPlaceholderId:'QingXuanZeChengShi',
                    cnPlaceholder:'请选择城市',
                    hiddenLabel:true,
                    className: 'row50',
                    type:"TransitCity",
                    gutter:8
                },
                {
                    type:"OnlyRender",
                    // showTitle:true,
                    // cnTitle:'注册时间',
                    // cnTitleId:'ZhuCeShiJian',
                    className: 'row100',
                    onlyRender: <div className={"black66 font_12 mb_4"}>{Lang({id:"ZhuCeShiJian",default:"注册时间"})}</div>
                },
                {
                    name:'times',
                    className: 'row100',
                    type:'DateRangePicker',
                    cnPlaceholder:['开始时间','结束时间'],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                },
                props.labelType=="1010"? null:{
                    type:"OnlyRender",
                    className: 'row100',
                    onlyRender: <div className={"black66 font_12 mb_4"}>{Lang({id:"ZuiJinXiaDanRiQi",default:"最近下单日期"})}</div>,
                },
                {
                    name:'lastOrderTime',//lastOrderTimeStart lastOrderTimeEnd
                    className: 'row100',
                    type:'DateRangePicker',
                    cnPlaceholder:['开始时间','结束时间'],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    hidden:props.labelType=="1010"?true:false,
                },
                {
                    name:'isTargetCustomer',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'是否目标客户',
                    cnPlaceholderId:'ShiFouMuBiaoKeHu',
                    type:"Select",
                    className: 'row50',
                    list:[{
                        id:"0",
                        name: Lang({id:"FeiMuBiaoKeHu",default:"非目标客户"}),
                    },{
                        id:"1",
                        name: Lang({id:"MuBiaoYongHu",default:"目标客户"}),
                    }],
                },
                {
                    name:'companyType',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请选择公司类型',
                    cnPlaceholderId:'QingXuanZeGongSiLeiXing',
                    className: 'row50Right',
                    type:"Enum",
                    enumClass:"buy_buyer_company_type"
                },
                {
                    name:'promoteModeId',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请选择渠道',
                    className: 'row50',
                    cnPlaceholderId:'QingXuanZeQuDao',
                    type:"SearchSelect",
                    searchClass:{
                        api:"/service/mg/follower/search/channel",
                        // nameField: 'name',
                        // idField:'id',
                    },
                },
                {
                    name:'userId',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请选择分销商',
                    cnPlaceholderId:'QingXuanZeFenXiaoShang',
                    className: 'row50Right',
                    type:"SearchSelect",
                    searchClass:{
                        api:"/service/mg/follower/search/user",
                    },
                },
                {
                    name: 'mainCategorys',//'mainCategoryIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请选择经营类目',
                    cnPlaceholderId:'QingXuanZeJingYingLeiMu',
                    className: 'row100',
                    type:"Category",
                    hiddenLabel:true,
                },
                {
                    name:'labelTypeList',
                    cnTitle:'',
                    cnTitleId:'',
                    hidden: props.isAllTab?false:true,
                    cnPlaceholder:'请选择客户阶段',
                    className: 'row100',
                    cnPlaceholderId:'QingXuanZeKeHuJieDuan',
                    type:"Enum",
                    mode:"multiple",
                    enumClass:props.labelType=="1010"?"essaone_new_buyer_label_type":"essaone_buyer_label_type",///	1010:新客标签 1020:成交客户标签
                },
            ]
        }
    }
    loading(flag=false){
        this.setState({
            loading: flag
        })
    }
    reset(){
        this.onRefFormFormat.handleReset();
        this.props.searchReset();
        this.setState({
            formValues:{},
            formValuesLength:0,
        })
    }
    /**
     * 点击确认时 获取表单数据
     ***/
    async handleOK(){
        const res = await this.onRefFormFormat.handleOK();
        if(res&&res.success){
            const values = res.data;
            if(values.times){
                const rangeValue = values.times;
                values['startTime'] =  dayjs(rangeValue[0]).startOf('day').valueOf();//开始时间
                values['endTime'] =  dayjs(rangeValue[1]).add(1, 'days').startOf('day').valueOf();//结束时间
                delete values.times;
            }
            if(values.lastOrderTime){
                const rangeValue = values.lastOrderTime;
                values['lastOrderTimeStart'] =  dayjs(rangeValue[0]).startOf('day').valueOf();//开始时间
                values['lastOrderTimeEnd'] =  dayjs(rangeValue[1]).add(1, 'days').startOf('day').valueOf();//结束时间
                delete values.lastOrderTime;
            }
            if(values.mainCategorys&&values.mainCategorys.length>0){
                let mainCategoryIdList = [];
                values.mainCategorys.forEach(cat=>mainCategoryIdList.push(cat.value));
                values.mainCategoryIdList = mainCategoryIdList;
                delete values.mainCategorys;
            }
            this.props.search(values);
            this.setState({
                formValues:values,
                formValuesLength:Object.keys(values).length
            })
        }
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    render(){
        const {loading, showyOptions,formValuesLength=0} = this.state;
        return (<Spin spinning={loading}>
                <Popover placement="bottom"
                         arrow={false}
                         overlayStyle={{width:"600px"}}
                         color={"#fff"}
                         trigger="click"
                         content={<div className={"popFormSeniorFilter"}>
                    <FormFormat onRef={this.onRefForm}
                                options={showyOptions}
                                formLayout="inline"//"vertical"
                                formItemLayout={{}}
                                size={"middle"}
                    />
                    <div className={"text-center"}>
                        <Button onClick={()=>this.reset(false)}>
                            {Lang({id:'ZhongZhi',default:'重置'})}
                        </Button>
                        <Button className="ml_8" type="primary" onClick={()=>this.handleOK()}>
                            {Lang({id:'ShaiXuan',default:'筛选'})}
                        </Button>
                    </div>
                </div>}>
                    {this.props.labelType!='1030'?
                        <div className={`seniorFilter ml_16 black89 flex-item-ver-center`}>
                            <i className={"ri-filter-2-line font_18 mr_4"} />{Lang({id: "GaoJiShaiXuan",default: "高级筛选"})}
                            {formValuesLength>0?<span className={"filterNum ml_4"}>{formValuesLength}</span>:null}
                        </div>:null}

                </Popover>
            </Spin>
        )
    }
}

